import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  ApolloClient,
  InMemoryCache,
  NormalizedCacheObject,
  ApolloProvider,
} from '@apollo/client';
import { setContext } from 'apollo-link-context';
import { createHttpLink } from 'apollo-link-http';
import { onError } from 'apollo-link-error';

// Create an http link:
const httpLink = createHttpLink({
  uri: '/graphql',
});

const errorLink = onError(
  ({ response, operation, graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      console.log('graphQLErrors:');
      graphQLErrors.forEach((error) => {
        console.log(error);
      });
      console.log(response?.errors);
      // const redirectErrors = graphQLErrors.filter(
      //   (graphQLError) => graphQLError.statusCode === 401
      // );
      // if (redirectErrors.length > 0 && redirectErrors[0].location) {
      //   document.location = redirectErrors[0].location;
      // }
    }
  }
);

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem('token');
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `${token}` : '',
    },
  };
});

const client: ApolloClient<NormalizedCacheObject> = new ApolloClient({
  link: authLink.concat(errorLink).concat(httpLink) as any,
  cache: new InMemoryCache(),
  // defaultOptions: {
  //   watchQuery: {
  //     fetchPolicy: 'cache-and-network',
  //     errorPolicy: 'all',
  //   },
  //   query: {
  //     fetchPolicy: 'network-only',
  //     errorPolicy: 'all',
  //   },
  //   mutate: {
  //     errorPolicy: 'none',
  //   },
  // },
});

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
    ,
  </React.StrictMode>,

  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
